import * as Yup from 'yup';
import { Shape } from '../yup_types';
import { IPartnerFees } from '../../store/merchnts/merchant-interfaces';

export enum PARTNER_FEES_FORM_FIELDS {
	NAME = 'name',
	TYPE = 'type',
	APPLIED_ON = 'appliedOn',
	GROUP = 'group',
	AMOUNT = 'amount',
	MIN_FEE_AMOUNT = 'minimumFeeAmount',
	IS_ACTIVE = 'isActive',
}

export enum PARTNER_FEES_FORM_FIELDS_NAMES {
	NAME = 'Name',
	TYPE = 'Type',
	AMOUNT = 'Amount',
	MIN_FEE_AMOUNT = 'Min fee amount ($)',
	APPLIED_ON = 'Applied on',
	GROUP = 'Group',
	IS_ACTIVE = 'Is active',
}

export interface IPartnerFeesTypes {
	[PARTNER_FEES_FORM_FIELDS.NAME]: string,
	[PARTNER_FEES_FORM_FIELDS.TYPE]: string | number,
	[PARTNER_FEES_FORM_FIELDS.AMOUNT]: string | number,
	[PARTNER_FEES_FORM_FIELDS.MIN_FEE_AMOUNT]: string | number,
	[PARTNER_FEES_FORM_FIELDS.APPLIED_ON]: string,
	[PARTNER_FEES_FORM_FIELDS.GROUP]: string,
	[PARTNER_FEES_FORM_FIELDS.IS_ACTIVE]: boolean,
}

export interface IPartnerFeesReturnTypes {
	name: string,
	type: string | number,
	amount: number,
	minimumFeeAmount: number,
	appliedOn: string,
	group: string,
	isActive: boolean,
	id?: string,
}

// @ts-ignore
export const getPartnerDetailsSchema = (): Yup.SchemaOf<IPartnerFeesTypes> => Yup.object<Shape<IPartnerFeesTypes>>().shape({
	[PARTNER_FEES_FORM_FIELDS.NAME]: Yup.string()
		.required('Name is required'),
	[PARTNER_FEES_FORM_FIELDS.TYPE]: Yup.string()
		.required('Type is required'),
	[PARTNER_FEES_FORM_FIELDS.AMOUNT]: Yup.number()
		.required('Amount is required'),
	[PARTNER_FEES_FORM_FIELDS.MIN_FEE_AMOUNT]: Yup.number()
		.required('Min fee amount is required'),
  [PARTNER_FEES_FORM_FIELDS.APPLIED_ON]: Yup.string()
		.typeError('Please put proper value'),
});

export const partnerFeesInitialValues: IPartnerFeesTypes = {
	[PARTNER_FEES_FORM_FIELDS.NAME]: '',
	[PARTNER_FEES_FORM_FIELDS.TYPE]: '',
	[PARTNER_FEES_FORM_FIELDS.AMOUNT]: '',
	[PARTNER_FEES_FORM_FIELDS.MIN_FEE_AMOUNT]: '',
	[PARTNER_FEES_FORM_FIELDS.APPLIED_ON]: 'PER_TRANSACTION',
	[PARTNER_FEES_FORM_FIELDS.GROUP]: '',
	[PARTNER_FEES_FORM_FIELDS.IS_ACTIVE]: false,
};

export const convertToPartnerFeesInitialValues = (data: IPartnerFees): IPartnerFeesTypes => ({
	[PARTNER_FEES_FORM_FIELDS.NAME]: data?.name ? data?.name : '',
	// [PARTNER_FEES_FORM_FIELDS.TYPE]: data?.type === 1 ? 'fixed' : 'percentage',
	[PARTNER_FEES_FORM_FIELDS.TYPE]: data?.type,
	[PARTNER_FEES_FORM_FIELDS.AMOUNT]: data?.amount ? Number(data?.amount) / 100 : '',
	[PARTNER_FEES_FORM_FIELDS.MIN_FEE_AMOUNT]: data?.minimumFeeAmount ? Number(data?.minimumFeeAmount) / 100 : '',
	[PARTNER_FEES_FORM_FIELDS.APPLIED_ON]: data?.appliedOn ? data?.appliedOn : '',
	[PARTNER_FEES_FORM_FIELDS.GROUP]: data?.group ? data?.group : '',
	[PARTNER_FEES_FORM_FIELDS.IS_ACTIVE]: data?.isActive,
});
export const getFormattedPartnerFeesFields = (formikValues): IPartnerFeesReturnTypes => ({
	name: formikValues?.[PARTNER_FEES_FORM_FIELDS.NAME],
	type: formikValues?.[PARTNER_FEES_FORM_FIELDS.TYPE],
	amount: Number(formikValues?.[PARTNER_FEES_FORM_FIELDS.AMOUNT]) * 100,
	minimumFeeAmount: Number(formikValues?.[PARTNER_FEES_FORM_FIELDS.MIN_FEE_AMOUNT]) * 100,
	appliedOn: formikValues?.[PARTNER_FEES_FORM_FIELDS.APPLIED_ON],
	group: formikValues?.[PARTNER_FEES_FORM_FIELDS.GROUP],
	isActive: formikValues?.[PARTNER_FEES_FORM_FIELDS.IS_ACTIVE],
});
// export const getFormattedInitialPartnerFeesFields = (data): IPartnerFeesTypes => ({
// 	name: data?.name,
// 	type: data?.type,
// 	amount: data?.amount,
// 	minimumFeeAmount: data?.minimumFeeAmount
// });
